import { observer } from 'mobx-react';
import { NonEmptyList } from 'nonempty-list';
import * as React from 'react';
import ProgramDashboard from '.';
import { findLink } from '../../../LinkyLinky';
import { ProgramResource } from '../../../ProgramsStore/Types';
import ProgramNotReady from '../ProgramNotReady';

interface Props {
  programs: NonEmptyList<ProgramResource>;
}

const ProgramDashboards: React.FC<Props> = ({ programs }) => {
  return (
    <>
      {programs.toArray().map((programResource, i) => {
        const { payload } = programResource;
        return findLink('self', programResource.links)
          .map(() => (
            <div data-test-program-index={i}>
              <ProgramDashboard key={payload.id} programResource={programResource} />
            </div>
          ))
          .getOrElse(() => <ProgramNotReady key={payload.id} programResource={programResource} />);
      })}
    </>
  );
};

export default observer(ProgramDashboards);
